import { render, staticRenderFns } from "./Step.vue?vue&type=template&id=020e8623&scoped=true"
import script from "./Step.vue?vue&type=script&lang=ts"
export * from "./Step.vue?vue&type=script&lang=ts"
import style0 from "./Step.vue?vue&type=style&index=0&id=020e8623&prod&lang=scss&scoped=true"
import style1 from "./Step.vue?vue&type=style&index=1&id=020e8623&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020e8623",
  null
  
)

export default component.exports